module.exports = __webpack_public_path__ + "static/media/website-link.e316b8da.svg";